module.exports = __webpack_public_path__ + "static/media/cloud-2104829_640.2e3fb916.jpg";